var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { faPlay, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useEventBus } from "@vueuse/core";
import { GalaxyApi } from "@/api";
import {} from "@/api/invocations";
import {} from "@/api/workflows";
import { useHistoryStore } from "@/stores/historyStore";
import { useWorkflowStore } from "@/stores/workflowStore";
import _l from "@/utils/localization";
import { rethrowSimple } from "@/utils/simple-error";
import {} from "./types";
const { emit } = useEventBus("grid-router-push");
/**
 * Request and return invocations from server
 */
export function getData(offset, limit, search, sort_by, sort_desc, extraProps) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const params = {
            limit,
            offset,
            sort_by: sort_by,
            sort_desc,
            include_nested_invocations: false,
        };
        if (extraProps && "include_terminal" in extraProps) {
            params["include_terminal"] = extraProps["include_terminal"];
        }
        if (extraProps && "user_id" in extraProps) {
            params["user_id"] = extraProps["user_id"];
        }
        const { response, data, error } = yield GalaxyApi().GET("/api/invocations", { params: { query: params } });
        if (error) {
            rethrowSimple(error);
        }
        fetchHistoriesAndWorkflows(data);
        const headers = response.headers;
        const totalMatches = parseInt((_a = headers.get("total_matches")) !== null && _a !== void 0 ? _a : "0");
        return [data, totalMatches];
    });
}
/**
 * Fetch histories and workflows for the given invocations, if not already loaded,
 * so that they are cached and names are available for display in the grid
 */
function fetchHistoriesAndWorkflows(invocations) {
    const historyStore = useHistoryStore();
    const workflowStore = useWorkflowStore();
    const historyIds = new Set();
    const workflowIds = new Set();
    invocations.forEach((invocation) => {
        historyIds.add(invocation.history_id);
        workflowIds.add(invocation.workflow_id);
    });
    historyIds.forEach((history_id) => historyStore.getHistoryById(history_id) || historyStore.loadHistoryById(history_id));
    workflowIds.forEach((workflow_id) => workflowStore.fetchWorkflowForInstanceIdCached(workflow_id));
}
/**
 * Actions are grid-wide operations
 */
const actions = [
    {
        title: "Import Invocation",
        icon: faPlus,
        handler: () => {
            emit("/workflows/invocations/import");
        },
    },
];
/**
 * Declare columns to be displayed
 */
const fields = [
    {
        key: "expand",
        title: null,
        type: "expand",
    },
    {
        key: "workflow_id",
        title: "Workflow",
        type: "link",
        handler: (data) => {
            const invocation = data;
            emit(`/workflows/invocations/${invocation.id}`);
        },
        converter: (data) => {
            const workflowStore = useWorkflowStore();
            const invocation = data;
            return workflowStore.getStoredWorkflowNameByInstanceId(invocation.workflow_id);
        },
    },
    {
        key: "history_id",
        title: "History",
        type: "history",
    },
    {
        key: "create_time",
        title: "Invoked",
        type: "date",
    },
    {
        key: "state",
        title: "State",
        type: "helptext",
        converter: (data) => {
            const invocation = data;
            return `galaxy.invocations.states.${invocation.state}`;
        },
    },
    {
        key: "execute",
        title: "Run",
        type: "button",
        icon: faPlay,
        condition: (data) => {
            const invocation = data;
            const workflowStore = useWorkflowStore();
            const workflow = workflowStore.getStoredWorkflowByInstanceId(invocation.workflow_id);
            return !(workflow === null || workflow === void 0 ? void 0 : workflow.deleted);
        },
        handler: (data) => {
            const invocation = data;
            const workflowStore = useWorkflowStore();
            emit(`/workflows/run?id=${workflowStore.getStoredWorkflowIdByInstanceId(invocation.workflow_id)}`);
        },
        converter: () => "",
    },
];
/**
 * Grid configuration
 */
const gridConfig = {
    id: "invocations-grid",
    actions: actions,
    fields: fields,
    getData: getData,
    plural: "Workflow Invocations",
    sortBy: "create_time",
    sortDesc: true,
    sortKeys: ["create_time"],
    title: "Workflow Invocations",
};
export default gridConfig;
